<template>
    <div class="container-card">
        <div class="title">
            <van-image class="cover" width="60" height="80" lazy-load fit="contain" :src="data.card.image" 
                @click="preview"
            />
            <div class="right">
                <div class="t">卡牌系列：{{ data.card.seriesName }}</div>
                <div class="t">卡牌类型：{{ data.card.brandName }}</div>
                <div class="t">卡牌名称：{{ data.card.cardName }}</div>
            </div>
        </div>

        <!-- <div class="dashboard">
            <van-grid :border="false" :column-num="2" :gutter="1">
                <van-grid-item v-for="(item, index) in datas">
                    <div :class="{ item: true }">
                        <div class="t">
                            <div class="divider"></div>
                            <div class="label">{{item.label}}</div>
                        </div>
                        <div class="b">{{item.value}}</div>
                    </div>
                </van-grid-item>
                <div :class="{ item: true }">
                    <div class="t">
                        <div class="divider"></div>
                        <div class="label">xxxxx</div>
                    </div>
                    <div class="b">xxdsssssssssssssssssssssssssssssssssssdxxxx</div>
                </div>
            </van-grid>
        </div> -->

        <div class="dashboard">
            <div :class="{ item: true, last: datas.length === index }" v-for="(item, index) in datas">
                <div class="sub-item">
                    <div class="t">
                        <div class="divider" :style="{ 'background-color': color }"></div>
                        <div class="label">{{ item[0].label }}</div>
                    </div>
                    <div class="b">{{ item[0].value ?  item[0].value : '-' }}</div>
                </div>
                <div class="sub-item" v-if="item[1]">
                    <div class="t">
                        <div class="divider" :style="{ 'background-color': color }"></div>
                        <div class="label">{{ item[1].label }}</div>
                    </div>
                    <div class="b">{{ item[1].value ?  item[1].value : '-' }}</div>
                </div>
            </div>
            <div :class="{ sItem: true }" v-if="effect1">
                <div class="t">
                    <div class="divider" :style="{ 'background-color': color }"></div>
                    <div class="label">进化源效果</div>
                </div>
                <div class="b">{{effect1 ? effect1 : '-'}}</div>
            </div>
            <div :class="{ sItem: true }" v-if="effect2">
                <div class="t">
                    <div class="divider" :style="{ 'background-color': color }"></div>
                    <div class="label">效果</div>
                </div>
                <div class="b">{{effect2 ? effect2 : '-'}}</div>
            </div>
            <div :class="{ sItem: true }" v-if="effect3">
                <div class="t">
                    <div class="divider" :style="{ 'background-color': color }"></div>
                    <div class="label">能力</div>
                </div>
                <div class="b">{{effect3 ? effect3 : '-'}}</div>
            </div>
        </div>

        <!-- <div class="card-charts" id="card-charts"></div> -->


        <!-- <div class="empty">
            <van-image class="image" fit="contain"
                src="https://oss.turingsenseai.com/1724132791628289701.jpg" />
                <div class="text">很抱歉，暂未找到相应价格~</div>
        </div> -->

        <div @click="feedback" class="feedback">遇到问题？留言反馈</div>
    </div>
</template>

<script>
import { Toast, ImagePreview, Image } from "vant";
import { cardClassifyDetail, myCardClassifyDetail } from "@/common/api/card.js";
import * as echarts from 'echarts';

export default {
    components: {
        [ImagePreview.Component.name]: ImagePreview.Component,
    },
    data() {
        return {
            takePhoto: false,
            success: false,
            loading: false,
            imgUrl: null,
            data: {card:{}},
            datas: [],
            color: '#5EA9FF',
            classifyId: '',
            effect1: false,
            effect2: false,
            effect3: false,
        };
    },
    methods: {
        preview(){
            ImagePreview({
                images: [this.data.card.image],
                startPosition: 0,
                closeable: true
            })
        },
        feedback() {
            if (typeof wx !== undefined) {
                wx.miniProgram.redirectTo({
                    url: `/subPackages/ai/card/feedback?classifyId=${this.classifyId}`,
                    success: (res) => {
                        console.log(res); // 页面跳转成功
                    },
                    fail: (err) => {
                        console.log(err); // 页面跳转失败
                    },
                });
            }
        },
        initEcharts() {
            function setOption() {
                let option;

                var data = [
                    [0, 2900,],
                    [1700, 2900],
                    [1400, 1700],
                    [500, 1400,],
                    [300, 900],
                ]

                var base = [];
                var min = [];
                var max = [];

                function format(data) {
                    data.forEach(function (item) {
                        base.push(item[0])

                        min.push({
                            value: 0,
                            label: {
                                show: item[0] ? true : false,
                                formatter: '' + item[0] + '',
                            },
                        })

                        max.push({
                            value: item[1] - item[0],
                            label: {
                                show: item[1],
                                formatter: '' + item[1] + '',
                            },
                            itemStyle: {
                                color: item[2]
                            },
                        })
                    })
                }
                format(data);

                option = {
                    color: ['rgba(255, 223, 60, 1)'],
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    legend: {
                        right: 0,
                        data: ['价格区间', '均价'],
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: false // 隐藏横坐标刻度标签
                        },
                        axisTick: {
                            show: false // 如果同时想隐藏 X 轴的刻度线，将此设置为 false
                        },
                        axisLine: {
                            show: false // 如果同时想隐藏 X 轴的轴线，将此设置为 false
                        },
                        data: ['', '', '', '', '']
                    },
                    yAxis: [
                        {
                            type: 'value',
                            splitLine: {
                                lineStyle: {
                                    type: 'dashed',
                                    color: "#909090"
                                }
                            },
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                show: false
                            },
                            interval: 600,
                            show: true
                        },
                        {
                            type: 'value',
                            interval: 100,
                            axisLabel: {
                                show: false,
                            },
                            axisLine: {
                                show: false
                            },
                            splitLine: {
                                show: false
                            },
                        }
                    ],
                    series: [
                        {
                            type: 'bar',
                            stack: '-',
                            barWidth: 11,
                            itemStyle: {
                                barBorderColor: 'rgba(0,0,0,0)',
                                color: 'rgba(0,0,0,0)'
                            },
                            emphasis: {
                                itemStyle: {
                                    barBorderColor: 'rgba(0,0,0,0)',
                                    color: 'rgba(0,0,0,0)'
                                }
                            },
                            data: base
                        },
                        {
                            type: 'bar',
                            stack: '-',
                            barWidth: 11,
                            label: {
                                show: true,
                                position: 'bottom',
                                color: '#909090'
                            },
                            tooltip: {
                                show: false
                            },
                            itemStyle: {
                                normal: {
                                    barBorderRadius: [2, 2, 2, 2] // 统一设置四个角的圆角大小
                                }
                            },
                            data: min
                        },
                        {
                            name: '价格区间',
                            type: 'bar',
                            stack: '-',
                            barWidth: 11,
                            label: {
                                show: true,
                                position: 'top',
                                color: '#909090'
                            },
                            tooltip: {
                                show: false
                            },
                            itemStyle: {
                                normal: {
                                    barBorderRadius: [2, 2, 2, 2] // 统一设置四个角的圆角大小
                                }
                            },
                            data: max
                        },
                        {
                            name: '均价',
                            type: 'line',
                            yAxisIndex: 1,
                            data: [100, 100, 300, 200, 100, 50],
                            areaStyle: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: 'rgba(255, 223, 60, 0.4)' },
                                        { offset: 1, color: 'rgba(255, 223, 60, 0)' }
                                    ]
                                )
                            },

                        }
                    ]
                };


                return option;
            }

            const myCharts = echarts.init(document.getElementById('card-charts'));
            const option = setOption();
            myCharts.setOption(option)
        },

        splitArrayToPairs(arr) {
            let result = [];
            for (let i = 0; i < arr.length; i++) {
                if (i % 2 === 0) {
                    // 索引为偶数时，创建新的子数组
                    result.push([arr[i]]);
                } else {
                    // 索引为奇数时，将元素添加到上一个子数组
                    result[result.length - 1].push(arr[i]);
                }
            }
            return result;
        }

    },
    mounted() {
        const skc = this.$route.query.skc
        const classifyId = this.$route.query.classifyId
        const from = this.$route.query.from
        this.classifyId = classifyId;

        const req = from === 'my' ? myCardClassifyDetail({classifyId}): cardClassifyDetail({ skc })

        req.then((res) => {
            if (res.errorMsg === 'Success') {
                let graph;
                const d = res.detail ? res.detail : {};
                const c = res.card ? res.card: {};
                this.data = res.card ? res: {card:{}};
                if (d.pokemonCard) {
                    const pc = d.pokemonCard
                    this.color = '#F4DD67'
                    graph = [
                        {
                            label: '卡牌系列',
                            value: c.seriesName
                        },
                        {
                            label: '卡牌类型',
                            value: pc.cardType
                        },
                        {
                            label: '卡牌名称',
                            value: c.cardName
                        },
                        {
                            label: '稀有度',
                            value: pc.rarity
                        },
                        {
                            label: 'HP',
                            value: pc.hp
                        },
                        {
                            label: '属性',
                            value: pc.property
                        },
                        {
                            label: '图鉴编号',
                            value: pc.number
                        },
                        {
                            label: '宝可梦类型',
                            value: pc.pokemonType
                        },
                        {
                            label: '身高',
                            value: pc.Height
                        },
                        {
                            label: '体重',
                            value: pc.weight
                        },
                        {
                            label: '技能',
                            value: pc.skill
                        },
                        {
                            label: '弱点',
                            value: pc.weakness
                        },
                        {
                            label: '抗性',
                            value: pc.resistance
                        },
                        {
                            label: '撤退',
                            value: pc.retreat
                        },
                        {
                            label: '语言',
                            value: pc.language
                        },
                        {
                            label: '序号',
                            value: c.serialNum
                        },

                    ];
                }
                if (d.digimonCard) {
                    this.color = '#5EA9FF'
                    const pc = d.digimonCard
                    graph = [
                        {
                            label: '卡牌系列',
                            value: c.seriesName
                        },
                        {
                            label: '卡牌类型',
                            value: pc.cardType
                        },
                        {
                            label: '卡牌名称',
                            value: c.cardName
                        },
                        {
                            label: '序号',
                            value: c.serialNum
                        },
                        {
                            label: '稀有度',
                            value: pc.rarity
                        },
                        {
                            label: '颜色',
                            value: pc.color
                        },
                        {
                            label: '等级',
                            value: pc.level
                        },
                        {
                            label: '特征',
                            value: pc.features,
                        },
                        {
                            label: '登场费用',
                            value: pc.cost,
                        },
                        {
                            label: '进化条件',
                            value: pc.evolutionCondition
                        },
                        {
                            label: 'DP',
                            value: pc.dp
                        },

                    ];
                    if(pc.effect){
                        this.effect2 = pc.effect
                    }
                    if(pc.evolutionEffect){
                        this.effect1 = pc.evolutionEffect
                    }

                }
                if (d.onePieceCard) {
                    this.color = '#E52444'
                    const pc = d.onePieceCard

                    graph = [
                        {
                            label: '卡牌系列',
                            value: c.seriesName
                        },
                        {
                            label: '卡牌类型',
                            value: pc.cardType
                        },
                        {
                            label: '卡牌名称',
                            value: c.cardName
                        },
                        {
                            label: '序号',
                            value: c.serialNum
                        },
                        {
                            label: '稀有度',
                            value: pc.rarity
                        },
                        {
                            label: '颜色',
                            value: pc.color
                        },
                        {
                            label: '触发',
                            value: pc.trigger
                        },
                        {
                            label: '特征',
                            value: pc.features,
                        },
                        {
                            label: '登场费用',
                            value: pc.cost,
                        },
                        {
                            label: '力量',
                            value: pc.power
                        },
                        {
                            label: '反击',
                            value: pc.counterattack
                        },
                    ];
                    if(pc.ability){
                        this.effect3 = pc.ability;
                    }
                }

                if (d.yuGiOhCard) {
                    this.color = '#BE2A7D'
                    const pc = d.yuGiOhCard

                    graph = [
                        {
                            label: '卡牌系列',
                            value: c.seriesName
                        },
                        {
                            label: '卡牌类型',
                            value: pc.cardType
                        },
                        {
                            label: '卡牌名称',
                            value: c.cardName
                        },
                        {
                            label: '序号',
                            value: c.serialNum
                        },
                        {
                            label: '属性',
                            value: pc.property
                        },
                        {
                            label: '星级',
                            value: pc.star
                        },
                        {
                            label: '特征',
                            value: pc.features
                        },
                        {
                            label: 'ATK',
                            value: pc.atk
                        },
                        {
                            label: 'DEF',
                            value: pc.def
                        },
                        {
                            label: '卡片编号',
                            value: pc.number
                        },
                        {
                            label: '生产年份',
                            value: pc.produceYear
                        },
                        {
                            label: 'Link',
                            value: pc.link
                        },
                    ];
                    if(pc.effect){
                        this.effect2 = pc.effect
                    }

                }

                this.datas = this.splitArrayToPairs(graph)
                
            }
        })
        // this.initEcharts()
    }
};
</script>

<style lang="scss">
.container-card {
    height: 100vh;
    background: linear-gradient(180deg, #313439 0%, #1E1C21 100%);
    padding: 25px;
    color: #fff;

    .title {
        height: 160px;
        display: flex;
        align-items: center;
        margin-top: 40px;
        margin-bottom: 30px;
        padding: 0px 40px;

        .cover {
            margin-right: 40px;
            box-shadow: 0px 1px 1px 0px #00000042, 0px 2px 2px 0px #0000003B, 0px 5px 3px 0px #00000021, 0px 9px 4px 0px #0000000A, 0px 14px 4px 0px #00000000;
        }

        .right {
            display: flex;
            flex-direction: column;
            font-size: 14px;

            .t {
                margin: 6px 0px;
            }

        }
    }

    .dashboard {
        width: 100%;
        // height: 202px;
        padding: 0px 15px;
        box-shadow: -1px -1px 15px 0px #3F454E40 inset;
        background: linear-gradient(270deg, #2A3239 0%, #242B34 31%, #3F454E 62.5%, #2E343B 100%);
        border-radius: 8px;

        box-shadow: 0px 20px 30px 0px #3F454E4D,
            0px 8px 15px 0px #3F454E4D,
            0px 4px 10px 0px #3F454E26,
            0px 2px 10px 0px #3F454E1A,
            3px 3px 10px 0px #3F454E40 inset,
            -1px -1px 15px 0px #3F454E40 inset;
        display: flex;
        flex-direction: column;


        .van-grid-item__content {
            background-color: transparent;
            padding: 5px 0;
            display: flex;
            align-items: flex-start;
        }

        .t {
            margin-left: 10px;
            margin-bottom: 12px;
            display: flex;
            align-items: center;

            .label {
                font-size: 18px;
                color: #909090;
            }

            .divider {
                width: 6px;
                height: 14px;
                border-radius: 14px;
                margin-right: 12px;
            }
        }

        .b {
            margin-left: 10px;
            font-size: 20px;
            font-weight: 400;
            color: #FFFFFF;
            margin-left: 30px;
        }

        .item {
            width: 100%;
            display: flex;
            padding-top: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #ffffff3d;

            .sub-item {
                flex: 1;
            }
            &:last-of-type {
                border-bottom: unset;
            }
        }
        .last {
            border-bottom: unset;
        }

        .sItem {
            width: 100%;
            flex-direction: column;
            border-bottom: 1px solid #ffffff3d;
            display: flex;
            padding-top: 20px;
            padding-bottom: 20px;
            &:last-of-type {
                border-bottom: none;
            }
        }



    }

    .card-charts {
        height: 414px;
        margin-top: 60px;
    }

    .empty {
        margin-top: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .image {
            width: 2*125px;
            height: 2*87px;
            margin-bottom: 20px;
        }

        .text {
            font-size: 30px;
            font-weight: 400;
            color: #E7E7E7;
        }
    }

    .feedback {
        text-align: center;
        text-decoration: underline;
        // position: fixed;
        // bottom: 100px;
        width: calc(100%);
        color: rgba(161, 161, 161, 1);
        margin-top: 200px;
    }


}
</style>